import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'webshield_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
    if (consent === 'accepted' && window.posthog) {
      window.posthog.opt_in_capturing();
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    if (window.posthog) window.posthog.opt_in_capturing();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    if (window.posthog) window.posthog.opt_out_capturing();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 16, left: '50%', transform: 'translateX(-50%)',
      zIndex: 1000, width: 'calc(100% - 32px)', maxWidth: 560,
      background: '#0d0d2b',
      border: '1px solid rgba(112,0,255,0.4)',
      borderRadius: 14,
      padding: '16px 20px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      display: 'flex', flexDirection: 'column', gap: 12,
    }}>
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <span style={{ fontSize: 20, flexShrink: 0 }}>🍪</span>
        <div>
          <p style={{ fontSize: 13, fontWeight: 700, color: '#fff', margin: '0 0 4px' }}>We use cookies</p>
          <p style={{ fontSize: 12, color: '#8898b0', margin: 0, lineHeight: 1.6 }}>
            We use analytics cookies (PostHog) to understand how you use WebShield and improve it.
            No advertising or third-party tracking. Read our{' '}
            <a href="/privacy" style={{ color: '#00F0FF', textDecoration: 'underline' }}>
              Privacy Policy
            </a>.
          </p>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button onClick={decline} style={{
          background: 'transparent', border: '1px solid #2a2a4a',
          borderRadius: 8, padding: '8px 18px',
          color: '#8898b0', fontSize: 13, cursor: 'pointer',
        }}>
          Decline
        </button>
        <button onClick={accept} style={{
          background: 'linear-gradient(135deg,#7000FF,#00F0FF)',
          border: 'none', borderRadius: 8, padding: '8px 20px',
          color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer',
        }}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;